@if (showHeader()) {
  <div class="modal-header">
    <!-- Prefix button slot (e.g., back button) -->
    <div class="modal-header-prefix">
      <ng-content select="[headerPrefix]" />
    </div>

    <h4 class="modal-title mb-0 text-truncate">
      <ng-content select="[title]" />
    </h4>

    <!-- Suffix button slot (e.g., close button) -->
    <div class="modal-header-suffix">
      <ng-content select="[headerSuffix]" />
      @if (showClose()) {
        <button type="button" class="btn btn-icon" type="button" (click)="activeModal.close()">
          <custom-icon name="close" class="text-secondary" [size]="20"></custom-icon>
        </button>
      }
    </div>
  </div>
}
<div class="modal-body">
  <ng-content select="[body]" />
</div>

@if (showFooter()) {
  <div class="modal-footer">
    <ng-content select="[footer]" />
  </div>
}
